"use client";

import React from "react";
import { PricingContent } from "./pricing-content";

const Pricing = () => {
  return (
    <div id="pricing" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <PricingContent />
      </div>
    </div>
  );
};

export default Pricing; 